import { API_ORDERS } from '../constants/common';
import { getLocation } from './environment';
import { Order } from '../typings/Order';
import {
  constants as coreConstants,
  dataServices,
  OrderData,
  Promise,
  services,
  User
} from '@ambita/ambita-components-core';

const INTERNAL_REQUEST_CONFIG = {
  headers: {
    'Call-Origin': 'internal'
  }
};

export function fetchOrder(orderId): Promise<any> {
  const url = dataServices.config.getConfig().API_HOST + API_ORDERS;
  return dataServices.xhr.getJSON(url + orderId, INTERNAL_REQUEST_CONFIG);
}

export function fetchOrderWhichRequiresSensitiveInfoAccess(orderId): Promise<any> {
  return fetchOrder(orderId)
    .then((order) => {
      return hasAccessToSensitiveInformation(order)
        .then(() => order)
        .catch(error => Promise.reject(error));
    });
}

export function hasAccessToSensitiveInformation(order: Order): Promise<boolean> {
  const unauthorized = new Error('User is not authorized to see this report');

  if (!order || !order.user || !order.user.ident) {
    return Promise.reject(unauthorized);
  }

  const url = `${dataServices.config.getConfig().AUTHENTICATION_USERS}/${order.user.ident}`;
  return dataServices.xhr.getJSON(url, INTERNAL_REQUEST_CONFIG)
    .then((user: User.User) => {
      const isSubscriptionUser = !!(user && user.organization &&
        user.organization.organizationType === coreConstants.user.AGREEMENT_CUSTOMER);

      if (isSubscriptionUser) {
        return;
      } else {
        return Promise.reject(unauthorized);
      }
    });
}

export function getProductOrderData(productCode: string, order: Order): OrderData.Data {
  for (const orderLine of order.orderLines) {
    if (orderLine.product === productCode) {
      return order.orderData;
    }
  }
  return null;
}

export function fetchGeoToken() {
  const location = getLocation();
  const queryParams = services.util.encodeUriQuery({
    expiration: 60,
    referer: location.protocol + '//' + location.host
  });
  const url = `${dataServices.config.getConfig().LOGIN_GEODATA_ADDRESS}?${queryParams}`;
  return dataServices.xhr.getJSON(url, INTERNAL_REQUEST_CONFIG);
}

export const getPropertyKeyFromOrderData = function getPropertyKey(orderData: OrderData.Data): string {
  if (orderData.realty.cadastre) {
    return services.util.objectToDelimitedString(orderData.realty.cadastre);
  } else if (orderData.realty.orgnr) {
    return `${orderData.realty.orgnr}-${orderData.realty.andelsnr}`;
  }
};
